export const MergeUserSettings = 'user/settings/MERGE'
